module.exports = __webpack_public_path__ + "static/media/d1.904490fe.png";